import React from 'react';
import AceEditor from 'react-ace';

import {PYTHON_STARTER_CODE} from './StarterCode';

interface UserDefinedFunctionEditorProps {
  config: string | null;
  onChangeConfig: (config: string | null) => void;
  disabled?: boolean;
}

export default function UserDefinedFunctionEditor({
  config,
  onChangeConfig,
  disabled,
}: UserDefinedFunctionEditorProps): JSX.Element {
  return (
    <AceEditor
      value={config ?? PYTHON_STARTER_CODE}
      onChange={onChangeConfig}
      mode="python"
      readOnly={disabled}
      showGutter={true}
      showPrintMargin={false}
      minLines={20}
      wrapEnabled={true}
      // TODO(BNCH-123236): Make height and width responsive
      width="500px"
      height="600px"
    />
  );
}
